
import React, { useState } from 'react';
import { IoClose } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { MdDataSaverOff } from "react-icons/md";

const Updateworklog = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white md:p-8 p-4 rounded shadow-md md:w-[80%] w-full md:m-0 m-3">
      <div className='flex gap-5 justify-between'>
        <button
          className=" uppercase flex items-center md:gap-2 gap-1"
          onClick={onClose}
        >
          <IoClose className='text-[#393e46] font-semibold uppercase' />
          cancel

        </button>

        <h1 className="text-sm uppercase text-[#696969] font-semibold">work log</h1>


        <button
          className=" uppercase flex items-center md:gap-2 gap-1"
          onClick={onClose}
        >
          <FaSave  className='text-[#393e46] font-semibold uppercase' />
          save

        </button>
        </div>


        <h5 className='text-sm text-[#696969] font-normal capitalize md:pt-10 pt-3 pb-2'>note</h5>
        <textarea name="" id="" placeholder='text' className='text-sm text-[#696969] capitalize md:p-6 p-3 border border-gray-400 rounded-lg resize-none w-full'></textarea>


        
        <button
          className=" uppercase flex items-center gap-2 md:mt-8 mt-4 bg-[#66b5a3] hover:bg-[#539e93] text-white justify-center w-full rounded-md p-3"
          onClick={onClose}
        >
          <FaSave  className='text-white font-semibold uppercase' />
          save

        </button>

        <div className='flex md:text-center text-start gap-3 mt-6 md:mx-4 mx-0 md:mb-10 mb-4 '>
        <MdDataSaverOff  className='text-[#66b5a3] md:text-2xl text-6xl'/>
        <p className="text-sm  text-[#393e46] font-normal"> You can define tasks so technicians can quickly choose what they have done. It is useful for statistics, for example how many tasks technician has done for certain period.</p>

        
        </div>
      
        
      
      </div>
    </div>
  );
};

export default Updateworklog;
